import GolfCoursesPage, { COURSES_LANDING_QUERY } from './landing/query'
import GolfCoursesCitiesPage from './state'

export { GolfCoursesCitiesPage, COURSES_LANDING_QUERY }

export default GolfCoursesPage
